module.exports = __webpack_public_path__ + "media/images/common/f-navi-arrow-c6032d39832c9760282c030966159dcc.svg";